
import filterBox from "./filter-box"
import sortBox from "./sort-box"
import list from "./list"
import aLinkPagination from "./aLinkPagination"
import filterTag from "./filter-tag"
import { wareSearch } from "@/api/category.js"
import { genfilterAndSortParams, getWareListAndResultTips } from "@/utils/category.js"
import { formatProductParamsBy } from "@/utils/utils"

export default {
  name: "WareViewIndex",
  API: ["handleSearch"],
  components: {
    filterBox,
    sortBox,
    list,
    // pagination,
    aLinkPagination,
    filterTag
  },
  props: {
    defaultFilterProperty: {
      type: Array,
      default: () => []
    },
    defaultList: {
      type: Array,
      default: () => []
    },
    defaultPageInfo: {
      type: Object,
      default: () => {}
    },
    category: {
      type: Object,
      default: () => {}
    },
    noResultData: {
      type: Object,
      default: () => {}
    },
    defaultKeyword: {
      type: String,
      default: ""
    },
    defaultSearchResultTip: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      total: 0,
      loading: false,
      noResult: false,
      searchResultTip: "",
      keyword: "",
      commonReqParams: {},
      cateReqParams: {},
      filterAndSortParams: {
        filterProperties: [],
        sortType: 0,
        sortRule: 0
      },
      paginationParams: {},
      wareList: [],
      filterProperty: [],
      categoryName: "",
      pageInfo: {}
    }
  },

  computed: {
    showFilter() {
      return this.filterProperty && this.filterProperty.length
    },
    hasWare() {
      return this.wareList && this.wareList.length
    },
    showPagination() {
      return this.total > this.pageInfo.pageSize
    },
    sortValue() {
      return {
        sortKey: Number(this.filterAndSortParams.sortKey),
        sortRule: Number(this.filterAndSortParams.sortRule)
      }
    },
    categoryArr() {
      return this.category?.pathName?.map(item => item.name) || []
    }
  },
  watch: {
    defaultSearchResultTip: {
      handler(newVal) {
        this.searchResultTip = newVal
      },
      immediate: true
    },
    noResultData: {
      handler(newVal) {
        this.$nextTick(() => {
          if (newVal && newVal.resultObject && newVal.resultObject.length > 0) {
            this.searchResultTip = this.$t("search.noResultTip", { keyword: this.keyword })
            this.noResult = true
            this.wareList = newVal.resultObject[0].wareInfo
          } else {
            this.noResult = false
          }
        })
      },
      immediate: true
    },
    defaultList: {
      handler(newVal) {
        this.wareList = newVal
      },
      immediate: true
    },
    defaultKeyword: {
      handler(newVal) {
        this.keyword = newVal
        this.initFilterAndSortParams()
      },
      immediate: true
    },
    defaultFilterProperty: {
      handler(newVal) {
        this.filterProperty = newVal
      },
      immediate: true
    },
    defaultPageInfo: {
      handler(newVal) {
        this.pageInfo = newVal
        this.total = this.pageInfo.total || 0
        this.paginationParams = {
          pageNum: this.pageInfo.pageNum || 1,
          pageSize: this.pageInfo.pageSize || 20
        }
      },
      immediate: true
    },
    category: {
      handler(newVal) {
        if (!newVal) return
        this.cateReqParams = {
          categoryId: newVal.path[newVal.path.length - 1],
          categoryLevel: newVal.path.length
        }
        this.categoryName = newVal.name
      },
      immediate: true
    }
  },
  mounted() {
    const { commonReqParams } = this.$commonParams
    this.commonReqParams = {
      businessCode: commonReqParams.businessCode,
      categoryType: 1,
      erpStoreId: commonReqParams.storeId,
      venderId: commonReqParams.venderId
    }
    this.initFilterAndSortParams()
    document.title = this.$t("pageTitle.categoryName", { name: this.categoryName })
  },
  updated() {
    this.$bus.$emit("wareCountChange", {
      count: this.total,
      noResult: this.noResult
    })
  },

  methods: {
    changeQuery(query) {
      this.$router.push({
        name: this.$route.name,
        params: {
          ...this.$route.params,
          page: 1
        },
        query: {
          ...this.$route.query,
          ...query
        }
      })
    },
    async handleSearch(val, type) {
      switch (type) {
        case "pagination":
          this.paginationParams.pageNum = val
          break
        case "sort":
          this.filterAndSortParams.sortKey = val.sortKey
          this.filterAndSortParams.sortRule = val.sortRule
          this.initPaginationParams()
          this.changeQuery({
            sortKey: val.sortKey,
            sortRule: val.sortRule,
            page: 1
          })
          break
        case "condition":
          this.initPaginationParams()
          this.filterAndSortParams = {
            ...this.filterAndSortParams,
            ...val
          }
          this.changeQuery({
            proCatId: val?.filterProperties?.map(item => item.proCatId).join("-"),
            proId: val?.filterProperties?.map(item => item.proId).join("-"),
            page: 1
          })
          break
        default:
          break
      }
      const res = await this.getList()
      this.doSomeOp(res, type)
    },
    doSomeOp(res, type) {
      window.scrollTo(0, 0)
      switch (type) {
        case "pagination":
          break
        case "condition":
          break
        case "category":
          this.filterProperty = res.properties
          break
        default:
          break
      }
      this.pageInfo = res.pageInfo || {}
      this.wareList = res.wareList || []
      const wareListAndTips = getWareListAndResultTips(res, this.keyword)
      if (this.keyword) {
        this.searchResultTip = wareListAndTips.searchResultTip
      }
      this.total = res.pageInfo ? this.pageInfo.total : 0
      this.$bus.$emit("wareCountChange", {
        count: this.total,
        noResult: this.noResult
      })
    },
    initPaginationParams() {
      this.paginationParams = {
        pageNum: 1,
        pageSize: this.pageInfo.pageSize
      }
    },
    initFilterAndSortParams() {
      this.filterAndSortParams = genfilterAndSortParams(this.$route.query)
    },
    async getList() {
      this.loading = true
      const filterParams = JSON.parse(JSON.stringify(this.filterAndSortParams))
      try {
        const { data } = await wareSearch({
          param: {
            ...this.cateReqParams,
            ...this.commonReqParams,
            ...filterParams,
            ...this.paginationParams,
            keyword: this.keyword,
            ...formatProductParamsBy()
          }
        })
        return data
      } finally {
        this.loading = false
      }
    }
  }
}
